export default "__VITE_ASSET__rrPhjy7v__"